import { downloadDailyBalancePdf } from './dailyBalancePdf';

export const downloadDailyVarietyBalancePdf = ({ varietyName, ...options }) =>
  downloadDailyBalancePdf({
    ...options,
    blockLabel: `Variedad: ${varietyName}`,
    filenamePrefix: 'balance-diario-variedad',
    filenameSubject: varietyName,
    reportTitle: 'BALANCE DIARIO POR VARIEDAD',
  });
